export enum PasswordStatusEnum {
  CONFIRMED = 'confirmed_password',
  NEED_CHANGE = 'force_reset_password',
}
